import React, { useState } from 'react';
import useAuth from '../../hooks/useAuth';

function AuthPage() {
  const [activeTab, setActiveTab] = useState('login');
  const bgColorClass = activeTab === 'login' ? 'bg-indigo-500' : 'bg-transparent';
  const bgColorClassSignup = activeTab === 'signup' ? 'bg-indigo-500' : 'bg-transparent';
  const { login, signup, error, user, setError } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [signup_email, setSignUpEmail] = useState('');
  const [signup_password, setSignUpPassword] = useState('');
  const [signup_confirm_password, setSignUpConfirmPassword] = useState('');
  const [signup_name, setSignUpName] = useState('');

  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    const userData = await login({
      email: email,
      password: password,
    });
    if (userData) {
      window.location.href = "/dashboard";
      setError("");
    }
    setLoading(false);
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (signup_password !== signup_confirm_password) {
      setError("Passwords don't match");
      setLoading(false);
      return;
    }
    const userData = await signup({
      name: signup_name,
      email: signup_email,
      password: signup_password,
    });
    if (userData) {
      window.location.href = "/dashboard";
      setError("");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F5FF]">
      <div className="w-full max-w-xl bg-white rounded-lg shadow p-10">
        <div className="flex justify-center mb-6">
          <img src="/TS-Logov3.png" alt="TypeScience Logo" className="h-24 w-auto" />
        </div>
        <div className="p-5">
          <div className="mb-5 mt-10">
            <div className="sm:block">
              <nav className="relative z-0 rounded-lg flex divide-x divide-gray-300" aria-label="Tabs">
                <div
                  onClick={() => setActiveTab('login')}
                  className="cursor-pointer text-gray-900 rounded-l-lg group relative min-w-0 flex-1 overflow-hidden py-4 px-4 text-sm font-medium text-center focus:z-10"
                  aria-current="page"
                >
                  <span>Login</span>
                  <span aria-hidden="true" className={`absolute inset-x-0 bottom-0 h-0.5 ${bgColorClass}`}></span>
                </div>
                <div
                  onClick={() => setActiveTab('signup')}
                  className="cursor-pointer text-gray-900 rounded-r-lg group relative min-w-0 flex-1 overflow-hidden py-4 px-4 text-sm font-medium text-center focus:z-10"
                >
                  <span>Sign Up</span>
                  <span aria-hidden="true" className={`absolute inset-x-0 bottom-0 h-0.5 ${bgColorClassSignup}`}></span>
                </div>
              </nav>
            </div>
          </div>

          {activeTab === 'login' && (
            <>
              <div className="text-center mb-10">
                <p className="mb-3 text-2xl font-semibold leading-5 text-gray-900">Login to your account</p>
                <p className="mt-2 text-sm leading-4 text-gray-700">
                  Not a member yet? Create a free profile by taking our personality test or entering your results yourself.
                </p>
              </div>
              <form className="space-y-6" onSubmit={handleLogin}>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-900">
                    Email address
                  </label>
                  <div className="mt-1">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      required
                      className="appearance-none block w-full px-3 py-2 border border-[#7035DE] rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white text-gray-900"
                      placeholder="Email"
                      value={email}
                      onFocus={() => setError("")}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="password" className="block text-sm font-medium text-gray-900">
                    Password
                  </label>
                  <div className="mt-1">
                    <input
                      id="password"
                      name="password"
                      type="password"
                      autoComplete="current-password"
                      required
                      className="appearance-none block w-full px-3 py-2 border border-[#7035DE] rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white text-gray-900"
                      placeholder="Password"
                      value={password}
                      onFocus={() => setError("")}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div className="text-sm">
                    <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
                      Forgot your password?
                    </a>
                  </div>
                </div>
                <div>
                  {error && <p className="text-center text-sm mb-2 text-red-500">{error}</p>}
                  <button
                    type="submit"
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#7035DE] hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    disabled={loading}
                  >
                    {loading ? (
                      <div
                        className="inline-block h-6 w-6 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-primary motion-reduce:animate-[spin_1.5s_linear_infinite]"
                        role="status"
                      >
                        <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
                      </div>
                    ) : (
                      'Login'
                    )}
                  </button>
                </div>
              </form>
            </>
          )}

          {activeTab === 'signup' && (
            <>
              <div className="text-center mb-10">
                <p className="mb-3 text-2xl font-semibold leading-5 text-gray-900">Sign Up</p>
                <p className="mt-2 text-sm leading-4 text-gray-700">
                  Not a member yet? Create a free profile by taking our personality test or entering your results yourself.
                </p>
              </div>
              <form className="space-y-6" onSubmit={handleSignUp}>
                <div>
                  <label htmlFor="signup_name" className="block text-sm font-medium text-gray-900">
                    Name
                  </label>
                  <div className="mt-1">
                    <input
                      id="signup_name"
                      name="signup_name"
                      type="text"
                      autoComplete="name"
                      required
                      className="appearance-none block w-full px-3 py-2 border border-[#7035DE] rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white text-gray-900"
                      placeholder="Name"
                      value={signup_name}
                      onFocus={() => setError("")}
                      onChange={(e) => setSignUpName(e.target.value)}
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="signup_email" className="block text-sm font-medium text-gray-900">
                    Email address
                  </label>
                  <div className="mt-1">
                    <input
                      id="signup_email"
                      name="signup_email"
                      type="email"
                      autoComplete="email"
                      required
                      className="appearance-none block w-full px-3 py-2 border border-[#7035DE] rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white text-gray-900"
                      placeholder="Email"
                      value={signup_email}
                      onFocus={() => setError("")}
                      onChange={(e) => setSignUpEmail(e.target.value)}
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="signup_password" className="block text-sm font-medium text-gray-900">
                    Password
                  </label>
                  <div className="mt-1">
                    <input
                      id="signup_password"
                      name="signup_password"
                      type="password"
                      autoComplete="new-password"
                      required
                      className="appearance-none block w-full px-3 py-2 border border-[#7035DE] rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white text-gray-900"
                      placeholder="Password"
                      value={signup_password}
                      onFocus={() => setError("")}
                      onChange={(e) => setSignUpPassword(e.target.value)}
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="signup_confirm_password" className="block text-sm font-medium text-gray-900">
                    Confirm Password
                  </label>
                  <div className="mt-1">
                    <input
                      id="signup_confirm_password"
                      name="signup_confirm_password"
                      type="password"
                      autoComplete="new-password"
                      required
                      className="appearance-none block w-full px-3 py-2 border border-[#7035DE] rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white text-gray-900"
                      placeholder="Confirm Password"
                      value={signup_confirm_password}
                      onFocus={() => setError("")}
                      onChange={(e) => setSignUpConfirmPassword(e.target.value)}
                    />
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div className="text-sm">
                    <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
                      Forgot your password?
                    </a>
                  </div>
                </div>
                <div>
                  {error && <p className="text-center text-sm mb-2 text-red-500">{error}</p>}
                  <button
                    type="submit"
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#7035DE] hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    disabled={loading}
                  >
                    {loading ? (
                      <div
                        className="inline-block h-6 w-6 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-primary motion-reduce:animate-[spin_1.5s_linear_infinite]"
                        role="status"
                      >
                        <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
                      </div>
                    ) : (
                      'Sign Up'
                    )}
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AuthPage;